import { type FC } from 'react'
import { useIsMobileVariant } from '@dhl-ui/components'
import { Page } from './Page.js'
import { SubPage } from './SubPage.js'
import { type PageResponsiveProps } from './types.js'

/**
 * When on mobile you need a SubPage and on others you need a Page
 */
export const PageResponsive: FC<PageResponsiveProps> = (args) => {
  const isMobile = useIsMobileVariant()

  return isMobile ? <SubPage {...args} /> : <Page {...args} />
}
